import {validate} from "@learningblocks/shared-components/lib/Tracking/validator.js";

export function sendLog(props){

  // Remove unnessary event keys
  const eventName = props.event_type;
  const eventData = Object.keys(props).filter(key =>
    key !== 'event_type' &&
    key !== 'elementType' &&
    key !== 'action' &&
    (key !== 'component_type' || props['event_type'] === 'sim_log_impression') &&
    (key !== 'component_id' || props['event_type'] === 'sim_log_impression')
    ).reduce((obj, key) =>
    {
        obj[key] = props[key];
        return obj;
    }, {}
  );

  // Validate the event data
  const isValid = validate(eventData, process.env.NODE_ENV === 'dev');

  if(isValid){
      // Construct data object
      let data = {
        type: 'analytics',
        eventName: eventName,
        eventData: eventData,
      }

      // Push data into the data store
      window.parent.postMessage({ 
          method: 'event',
          data: data
      }, '*'); 
  }
}
